import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import 'xlsx/dist/xlsx.full.min.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import BasicCardMultipleValuesInfo from "../ui/BasicCardMultipleValuesInfo.js";
import MovilesGridExport from './MovilesGridExport';
import MovilesGridFiltrosExterno from './MovilesGridFiltros';
import GridSearchResultsBadge from '../../commons/filters/GridSearchResultsBadge.jsx';
import GridColumnSelector from '../../commons/grid/GridColumnSelector.jsx';
import LimpiarFiltros from '../../assets/images/limpiar-filtros.svg';
import SortableCell from '../../commons/grid/SortableCell.jsx';
import GridPagination from '../../commons/grid/GridPagination.jsx';
import useGridState from '../../commons/grid/useGridState.js';
import { buildMovilesQuery, CAMPOS_DE_ORDEN } from './movilesGridQuery.js';
import { GridLoadingRow, GridEmptyRow } from '../../commons/grid/GridStateRow.jsx';
import { GridToolbar, GridToolbarButton } from '../../commons/grid/GridToolbar.jsx';
import useColumnVisibility from '../../commons/grid/useColumnVisibility.js';
import { MOVILES_COLUMNAS_STORAGE_KEY, buildColumnsEnabled, buildMovilesColumns } from './movilesColumns.js';
import { migrarFiltrosPersistidos } from './movilesFilterFields.js';
import MovilesGridImport from './MovilesGridImport';
import MovilesGridRow from './MovilesGridRow';

var pdfMake = require('pdfmake/build/pdfmake.js')
var pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs

const PAGINATION_INIT ={
  page: 0,
  count: 0,
  perPage: 10,
}

const FILTER_QUERY_INIT = {
  estado:"",
  unidad: "",
  chasis: "",
  dominio: (ConfigBusiness.get('servicios.enableMultiSearch') == 'true') ? [] : "",
  medidor: "",
  base: "",
  pais: "",
  region: "",
  subRegion: "",
  titular: "",
  modelo: "",
  marca: "",
  tipo: "",
  centroCosto: "",
  cecosDireccion: "",
  cecosMercado: "",
  cecosGerencia: "",
  cecosArea: "",
  responsable1: "",
  responsables2: "",
  companiaOrigen: "",
  filtroKpi: "",
  showInactivos: '',
  medidorDesde: '',
	medidorHasta: '' ,
  supervisores: "",
  temporales: "",
  rutas: [],
  transportadora: [],
  rentadora: [],
  funcion: [],
  esReserva: "",
  // Faltaba, y getQuery() la manda igual: al resetear viajaba `estadoVinculacion=undefined`.
  estadoVinculacion: ""
}


// La persistencia previa guardaba `{activo, filtros}`, donde `activo` era el switch
// "Persistir Filtros". El switch ya no existe (la persistencia es siempre, y la card lo pide
// explícitamente) y el panel guarda el estado plano, así que lo que hubiera quedado se sube
// de nivel a la key nueva. Corre al importar el módulo, antes de que el panel lea
// localStorage al montar.
migrarFiltrosPersistidos()




const MovilesGrid = (props) => {
  const intl = useIntl()

  const [loading, setLoading] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  
  const [searchActive, setSearchActive] = useState(false)
  // Orden y paginado: el hook reemplaza el `sortQuery` con una clave por columna, el
  // `requestSort` de 40 líneas que las limpiaba todas a mano, y los dos handlers del paginador.
  // `sortQuery` sigue teniendo la misma forma, así que getQuery() no cambia.
  const {
    pagination,
    sortQuery,
    requestSort,
    setPage,
    setPerPage,
    reset: resetGridState,
  } = useGridState({ campos: CAMPOS_DE_ORDEN, perPage: PAGINATION_INIT.perPage })
  const [paginationCount, setPaginationCount] = useState(0);

  const [filterResetInputs,setFilterResetInputs] = useState(false)
  const [filterQuery, setFilterQuery] = useState(null)
  

  const [dropdownActive, setDropdownActive] = useState(false);

  
  const [moviles, setMoviles] = useState([]);
  const [estados,setEstados] = useState([]);
  const [movilesReserva, setMovilesReserva] = useState([]);
  const [movilesAsignados, setMovilesAsignados] = useState({});
  const movilesAsignadosRequestRef = useRef(0);

  //Alarmas Controles
  const [summaryAlerts, setSummaryAlerts] = useState(null)
  const [alertsClicked, setAlertsClicked] = useState([])

  //Enabled Columns Config
  // `Security` se consulta acá y el permiso se INYECTA: así movilesColumns.js no tiene que
  // importarlo (arrastra Firebase) y queda testeable.
  const [columnsEnabled,setColumnsEnabled] = useState(() =>
    buildColumnsEnabled({ disponibilidadListar: Security.hasPermission('DISPONIBILIDAD_LISTAR') })
  )
  
  //Security Permissions
  const [permissions,setPermissions] = useState({
    canModifyKM:false,
    canModifyCC:false,
    canReasignarCCsinRestriccion:false,
    movilesVisualizar:false,
    movilesModificar:false,
    movilesCrear:false,
    ticketsListar:false,
    vencimientosListar:false,
    vencimientosCrear:false,
    preventivosListar:false,
    correctivosCrear:false,
    movilesExportar: false,
    movilesImportar: false,
    movilesMoficiarReserva: false
  })

  // Qué columnas se ven. Son DOS ejes distintos y el hook los combina en `columnasVisibles`:
  // `columnsEnabled` dice qué columnas EXISTEN para este cliente (flags de config y permisos), y
  // la visibilidad dice cuáles de esas eligió ver el usuario. El mapa combinado se le pasa a
  // MovilesGridRow en la misma prop `columnsEnabled` que ya recibía, así las celdas no cambian.
  const columnas = buildMovilesColumns(columnsEnabled, permissions)
  const {
    visibles: columnasVisibles,
    esVisible: columnaEsVisible,
    toggle: toggleColumna,
    seleccionables: columnasSeleccionables,
    mostrarTodas: mostrarTodasLasColumnas,
  } = useColumnVisibility(columnas, MOVILES_COLUMNAS_STORAGE_KEY)

  // El colSpan real de las filas de "cargando" y "sin resultados". Estaba escrito a mano en 14,
  // con la grilla teniendo hasta 36 columnas: el spinner quedaba corrido y la tabla dibujaba
  // celdas vacías al costado.
  const columnasALaVista = Object.keys(columnasVisibles).filter((nombre) => columnasVisibles[nombre]).length
  
  const [modalExport,setModalExport] = useState(false)
  const [modalImport,setModalImport] = useState(false)
  const [modalImportMedidor,setModalImportMedidor] = useState(false)
  const [stateImport, setStateImport] = useState(false)
  const [selectFilter, setSelectFilter] = useState(null)

  const [estadosClasificador, setEstadosClasificador] = useState(null);
  const [estadosFiltro, setEstadosFiltro] = useState({estados: null});
  const [filtroEstadosClasificador, setFiltroEstadosClasificador] = useState({
    disponibles: null,
    arrayDisponibles: [],
    nodisponibles: null,
    arrayNodisponibles: []
  });

  useEffect(() => {
    fetchMovilesReserva();
  }, [moviles]);
  const fetchMovilesReserva = () => {
    Utils.getData(`/moviles/reserva-select`)
    .then((moviles) => {
      setMovilesReserva(moviles)
    });
  };


  useEffect(() => {
    setLoading(true)
    if (Security.hasPermission("MOVILES_LISTAR")) {
      securityPermission()
      filterQuery && fetchMoviles()
      controlesAlarmas()
      init();
    } else {
      setRedirectTo("/error")
    }
    //componentWillUnmount
    return () => { }
  }, [pagination,filterQuery,sortQuery,stateImport])

  const init = () => {
    let clasificador = ConfigBusiness.get('moviles.clasificador.habilitado') === "true" ? true : false;
    setEstadosClasificador(clasificador)
    if(clasificador){
      let disponible = ConfigBusiness.get('moviles.clasificador.disponible');
      filtroEstadosClasificador.disponibles = disponible;
      filtroEstadosClasificador.arrayDisponibles = disponible ? disponible.split(',') : [];

      let nodisponible = ConfigBusiness.get('moviles.clasificador.nodisponible');
      filtroEstadosClasificador.nodisponibles = nodisponible;
      filtroEstadosClasificador.arrayNodisponibles = nodisponible ? nodisponible.split(',') : null;
      let copy = JSON.parse(JSON.stringify(filtroEstadosClasificador));
      setFiltroEstadosClasificador(copy);
    }
  }


  const securityPermission = () => {
    let aux = {...permissions}
      aux.canModifyKM = Security.hasPermission('MOVILES_MODIFICAR_KM');
      // Habilita editar el Centro de Costos desde la grilla (VEC-3572). Es el mismo permiso con el
      // que el ABM muestra o esconde ese campo, para que la regla sea una sola.
      // Desde VEC-3815 el endpoint que guarda (POST /moviles/actualizar/centrocosto, compartido
      // con el ABM) SÍ valida este permiso server-side (antes era sólo gate de UI).
      aux.canModifyCC = Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION');
      // VEC-3815: para determinados perfiles, el selector de reasignación de CeCo muestra TODOS
      // los CeCo de la plataforma en vez de sólo los habilitados del usuario. Requiere AMBAS
      // condiciones: el permiso nuevo Y la config de instancia habilitada. El backend revalida
      // las dos siempre, así que este flag es sólo de UX (qué lista pedir).
      aux.canReasignarCCsinRestriccion = Security.hasPermission('MOVILES_REASIGNAR_CC_SIN_RESTRICCION')
        && ConfigBusiness.get('moviles.centroCostos.reasignacionSinRestriccion.habilitado') === 'true';
      aux.movilesVisualizar = Security.hasPermission('MOVILES_VISUALIZAR');
      aux.movilesModificar = Security.hasPermission('MOVILES_MODIFICAR');
      aux.movilesCrear = Security.hasPermission('MOVILES_CREAR');
      aux.ticketsListar = Security.hasPermission('TICKETS_MOVIL_LISTAR');
      aux.vencimientosListar = Security.hasPermission('VENCIMIENTOS_MOVIL_LISTAR');
      aux.vencimientosCrear = Security.hasPermission('VENCIMIENTOS_CREAR');
      aux.preventivosListar = Security.hasPermission('PREVENTIVOS_MOVIL_LISTAR');
      aux.correctivosCrear = Security.hasPermission('MANTENIMIENTOS_CORRECTIVOS_CREAR');
      aux.movilesExportar = Security.hasPermission('MOVILES_EXPORTAR');
      aux.movilesImportar = Security.hasPermission('MOVILES_IMPORTAR');
      aux.movilesMoficiarReserva = Security.hasPermission('MOVILES_RESERVA_LECTURA');
    setPermissions(aux)   
  }

  const generacionMasiva =  ConfigBusiness.get('tickets.generacionMasiva.habilitado') === 'true' ? true : false
  const [selectedMoviles, setSelectedMoviles] = useState([])
  const [allChecked, setAllCheked] = useState(false)

  const handleChecked = movil => e => {
    let selected = [...selectedMoviles]
    
    if (movil == 'all') {
      selected = [...moviles]
      setAllCheked(true)
    
    } else if (movil == 'none') {
      selected = []
      setAllCheked(false)
    
    } else {
      let idx = selected.indexOf(movil)
    
      if(selected.includes(movil)) selected.splice(idx, 1)
      else selected.push(movil)
      setAllCheked(true)
    }

    setSelectedMoviles(selected);
  }

  const controlesAlarmas = () => {
    Utils.getData(`/moviles/controles/alarmas`).then((data) => {
      let controles = data ? data : null;
      let alertsClicked = [];

      for(let alarm in controles){
        alertsClicked[controles[alarm].filter] = false;
      }

      // if(component.props.location.state && component.props.location.state.filter){
      //   alertsClicked[component.props.location.state.filter] = true;
      // }

      setSummaryAlerts(controles)
      // setAlertsClicked(alertsClicked)
    }).catch((err) => {
      console.log(err)
    })
  }
  const fetchMoviles = () => {
    Promise.all([
      Utils.getData(`/moviles/newGrid${getQuery()}`),
      ConfigBusiness.get('moviles.estados'),
    ])
    .then((data) => {
      var listaMoviles = data[0].moviles;
      setMoviles(listaMoviles);
      let estados = data[1] ? data[1].split(',') : null;
      let menuEstado = [];
      estados.forEach(estado => {
        menuEstado.push({ value: estado, label: estado });
      });
      setEstados(menuEstado);

      setLoading(false);
      setStateImport(false);
      setPaginationCount(data[0].pagination.count);

      // Fetch bulk de móviles asignados: solo si la columna está habilitada
      if (listaMoviles && listaMoviles.length > 0 && ConfigBusiness.get('moviles.movil_reserva.habilitado') === 'true') {
        var ids = listaMoviles.map(function(m) { return m.id; }).join(',');
        movilesAsignadosRequestRef.current += 1;
        var requestId = movilesAsignadosRequestRef.current;
        Utils.getData('/moviles/moviles-asignados?ids=' + ids)
          .then(function(respuesta) {
            if (requestId !== movilesAsignadosRequestRef.current) return;
            setMovilesAsignados(respuesta && respuesta.data ? respuesta.data : {});
          })
          .catch(function() {
            if (requestId !== movilesAsignadosRequestRef.current) return;
            setMovilesAsignados({});
          });
      } else {
        setMovilesAsignados({});
      }
    })
    .catch((err) => {
      setLoading(false);
    })
  };

  // El armado del query vive en ./movilesGridQuery.js: eran 58 concatenaciones a mano acá
  // adentro, sin forma de testearlas sin montar la grilla entera.
  const getQuery = () => buildMovilesQuery(pagination, filterQuery, sortQuery)

    const handleChangePage = (event, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => setPerPage(parseInt(event.target.value, 10));


    /**
     * LIMPIAR LA BÚSQUEDA — es lo que hace la "✕" de la franja de resultados.
     *
     * Devuelve los filtros al default y oculta la franja. NO toca el ordenamiento ni las
     * columnas visibles, y NO cierra el panel: es la regla del patrón (ver
     * docs/design-system/grid-filter-panel.md). Antes de VEC-3690 la "✕" hacía el reset total,
     * así que ordenar y después limpiar la búsqueda te devolvía también el orden.
     *
     * Sí vuelve a la página 0 y limpia el filtro de las tarjetas de alarmas: las dos cosas son
     * parte de la búsqueda vigente.
     */
    const handleSearchClear = () => {
      setPage(0);
      setFilterQuery(JSON.parse(JSON.stringify(FILTER_QUERY_INIT)));
      setSearchActive(false);
      setAlertsClicked([])
      setFilterResetInputs(true)
    }

    /**
     * RESET TOTAL — filtros, ordenamiento y columnas visibles, y cierra el panel.
     *
     * Reusa al parcial para no duplicar la parte de los filtros. Hoy NO tiene botón que lo
     * dispare: en Facturas y Tickets es el botón "Restaurar" del toolbar, que en Móviles todavía
     * no existe.
     */
    const handleFilterReset = () => {
      resetGridState();
      mostrarTodasLasColumnas();
      setDropdownActive(false);
      handleSearchClear();
    }

    /**
     * Lo que aplica el panel de filtros. Llega ya serializado a primitivos, con una clave por
     * campo declarado; se arma sobre FILTER_QUERY_INIT para conservar las claves que el panel
     * NO maneja: `filtroKpi` (sale de las tarjetas de alarmas) y `medidor` (quedó sin control
     * pero el backend la sigue recibiendo).
     */
    const handleApplyFilters = (query) => {
      const anterior = filterQuery || FILTER_QUERY_INIT;
      const nuevo = Object.assign({}, FILTER_QUERY_INIT, query, { filtroKpi: anterior.filtroKpi || "" });

      setPage(0);
      setFilterQuery(nuevo);
      // La franja verde se muestra cuando hay alguna búsqueda cargada. Móviles no tiene
      // filtros por defecto, así que alcanza con que algo no esté vacío.
      setSearchActive(Object.keys(query).some((k) => query[k] !== '' && query[k] !== undefined));
    }

    const handleAlertClick = (filter) =>{
      let copyClicked = alertsClicked;
      //si el filtro estaba seleccionado y se vuelve a clickear, se resetea
      let reset = false;
      if(alertsClicked[filter]){
        reset = true;
        copyClicked[filter] = !alertsClicked[filter];
      } else{
        for(let alarm in alertsClicked){
          copyClicked[alarm] = false;
        }
        copyClicked[filter] = true;
      }

      setAlertsClicked(copyClicked)
      
      let query = { ...filterQuery };
      query['filtroKpi'] = reset ? "" : filter;
      setFilterQuery(query);
    }

    const handleModalExportOpen = () => {
      setModalExport(true)
    };
  
    const handleModalExportClose = () => {
      setModalExport(false)
    };

    const handleModalImportOpen = () => {
      setModalImport(true)
    };

    const handleModalImportMedidorOpen = () => {
      setModalImportMedidor(true)
    };

    /**
     * El clasificador de estados del encabezado ("disponibles" / "no disponibles").
     *
     * Impone esos estados en el panel Y aplica el query: el override del panel solo sincroniza
     * los controles, no dispara onApply, así que sin esto se verían los chips elegidos con la
     * grilla sin filtrar. Los demás filtros se conservan (`overrideMerge`), como hacía el panel
     * viejo: el clasificador acota lo que ya había, no arranca de cero.
     */
    const setQueryClasificadorEstados = (estados) => {
      estadosFiltro.estados = estados
      let copy = JSON.parse(JSON.stringify(estadosFiltro));
      setEstadosFiltro(copy);

      if (estados) {
        setPage(0);
        setFilterQuery(Object.assign({}, filterQuery || FILTER_QUERY_INIT, { estado: estados }));
        setSearchActive(true);
        setDropdownActive(true);
      }
    };

    const generarCorrectivos = () => {
      if(selectedMoviles.length == 1) {
        let movil = selectedMoviles[0]
        setRedirectTo('/correctivos/add/movil/'+ movil.id +'/'+ movil.dominio)
      } else {
        // history v5 descarta el state cuando se lo pasa embebido en el objeto location
        // (que es lo que hace <Redirect to={{pathname, state}}> de react-router v4). Se
        // navega imperativamente con la firma push(path, state) de v5 para que
        // location.state llegue a CorrectivosAbm y se listen los móviles (VEC-3297).
        props.history.push('/correctivos/add/moviles', {moviles: selectedMoviles})
      }
    }
  const handleActualizarMovil = (movilActualizado, movilReservaAnterior = null) => {
    let agregarMovilReserva = false;
    const listaMovilesActualizada = moviles.map(movil => {
      if (movil.id === movilActualizado.id) {
        return {
          ...movil,
          movil_reserva: movilActualizado.movil_reserva
        }
      } else if (movilActualizado.movil_reserva && movil.id === movilActualizado.movil_reserva.id) {
        return {
          ...movil,
          es_reserva_asignada: 1
        }
      } else if (movilReservaAnterior && movil.id === movilReservaAnterior.id) {
        agregarMovilReserva = {
          value: movilReservaAnterior.id,
          label: `${movilReservaAnterior.dominio} - ${movilReservaAnterior.modelo_eloquent.nombre}`,
          es_reserva_asignada: 0,
          movil_reserva_id: null}
        return {
          ...movil,
          es_reserva_asignada: 0
        }
      } else {
        return movil;
      }
    });
    let listaMovilesReserva = movilesReserva.filter(movil => {
      return (
        movil.value !== movilActualizado.id &&
        (!movilActualizado.movil_reserva || movil.value !== movilActualizado.movil_reserva.id)
      );
    });
    if(agregarMovilReserva) listaMovilesReserva.push(agregarMovilReserva);

    setMoviles(listaMovilesActualizada);
    setMovilesReserva(listaMovilesReserva);

    const asignadosActualizado = { ...movilesAsignados };
    if (movilReservaAnterior) {
      delete asignadosActualizado[movilReservaAnterior.id];
    }
    if (movilActualizado.movil_reserva) {
      var titularEnGrilla = moviles.find(function(m) { return m.id === movilActualizado.id; });
      var dominioTitular = titularEnGrilla ? titularEnGrilla.dominio : (movilActualizado.dominio || null);
      if (dominioTitular) {
        asignadosActualizado[movilActualizado.movil_reserva.id] = dominioTitular;
      }
    }
    setMovilesAsignados(asignadosActualizado);
  };

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      {summaryAlerts &&
        <div className="row justify-content-center">
          {summaryAlerts.map((alert, index, array)=>{
            return(
              <div key={index} className={"col-xl-2 col-lg-4 col-md-6 col-12 cards-alerts-"+array.length} style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem",paddingBottom: "0.5rem"}}>
                <BasicCardMultipleValuesInfo
                  id={index}
                  onClickAlert={(filtro)=>handleAlertClick(filtro)}
                  values={alert}
                  selectFilter={selectFilter}
                  intl={intl}
                ></BasicCardMultipleValuesInfo>
              </div>
            );
          })}
        </div>
      }
      <MovilesGridExport open={modalExport} handleClose={handleModalExportClose} queryFilters={getQuery}/>

      <MovilesGridImport 
        openImport={modalImport}
        openImportMedidor={modalImportMedidor}
        setModalImport={setModalImport}
        setModalImportMedidor={setModalImportMedidor}
        setStateImport={setStateImport}
        intl={intl}
      />

      <div className="card">
        <div className="card-content collpase show">
          <div className="card-body card-dashboard">
            <div className="container-fluid mb-1">
              <div className="row dt-icons">
                <div className="col">
                  {permissions.movilesCrear && 
                    <StyledTooltip
                      title={intl.formatMessage({
                        id: 'movilesGrid.render.button_add.title_nuevo',
                        defaultMessage: 'Nuevo',
                      })}
                      arrow
                      placement="right"
                    >
                      <div
                        className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                        onClick={() => setRedirectTo(props.match.url + '/add')}
                      >
                        <i className="ft-plus"></i>
                      </div>
                    </StyledTooltip>
                  }
                    <div
                      className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                      onClick={() => setDropdownActive(!dropdownActive)}
                    >
                      {dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
                    </div>
                </div>
                <div className="col">
                  <GridSearchResultsBadge
                    visible={searchActive}
                    mostrados={moviles.length}
                    total={paginationCount}
                    onReset={() => handleSearchClear()}
                  />
                </div>
                <div className="col d-flex justify-content-end align-items-center">
                  {/* Reset TOTAL: filtros, columnas y ordenamiento. Es el otro reset del patrón
                      —la "✕" de la franja solo limpia la búsqueda— y el único lugar desde donde
                      se pueden recuperar las columnas ocultas. */}
                  <GridToolbar>
                    <GridToolbarButton
                      messageId="movilesGrid.tools_restore.title_restaurar_vista"
                      label="Restaurar filtros, columnas y ordenamiento"
                      onClick={() => handleFilterReset()}
                    >
                      <img id="filterReset" className="filter-reset" src={LimpiarFiltros} alt="" />
                    </GridToolbarButton>
                    {/* El selector va DENTRO del GridToolbar, como en Tickets: la regla
                        `.dt-buttons .btn` de vec-datatables.css es la que le saca el fondo y el
                        borde. Afuera queda con el borde gris del `btn-secondary` de Bootstrap. */}
                    <GridColumnSelector
                      columns={columnasSeleccionables}
                      esVisible={columnaEsVisible}
                      onToggle={toggleColumna}
                    />
                  </GridToolbar>
                  <ButtonsTableTop 
                    intl={intl}
                    permissions={permissions}
                    handleModalExportOpen={handleModalExportOpen} 
                    handleModalImportOpen={handleModalImportOpen} 
                    handleModalImportMedidorOpen={handleModalImportMedidorOpen}
                  />
                </div>
              </div>
            </div>
          
            <MovilesGridFiltrosExterno
              open={dropdownActive}
              columnsEnabled={columnsEnabled}
              loading={loading}
              resetSignal={filterResetInputs}
              onResetSignalHandled={() => setFilterResetInputs(false)}
              overrideEstados={estadosFiltro.estados}
              onOverrideHandled={() => setQueryClasificadorEstados(null)}
              onApply={handleApplyFilters}
            />
            <TableContainer>
              <Table aria-label="clases table" className="table-hover">
                {(generacionMasiva && selectedMoviles.length > 0 ) ? (
                <TableHead>
                  <TableRow>
                    <StyledTableCell show={generacionMasiva && selectedMoviles.length > 0 } colSpan={16}>
                      <input type="checkbox" checked={allChecked} onChange={handleChecked('none')} style={{marginRight: "15px"}} className="customCheckbox"/>
                      <span style={{marginRight: "10px"}}>{selectedMoviles.length}</span>
                      <FormattedMessage id="movilesGrid.render.generacionMasiva.seleccionados" defaultMessage="Seleccionados "/>
                        | 
                      <StyledTooltip 
                        title={intl.formatMessage({
                          id: 'render.generacionMasiva.crear_correctivos',
                          defaultMessage: 'Crear Correctivos',
                        })}
                        arrow
                        placement="top"
                      >
                        <i
                        type="button"
                        onClick={generarCorrectivos}
                        className="fa fa-wrench fa-1_4x cursor-pointer"
                        style={{ marginLeft: "10px" }}
                        ></i>
                      </StyledTooltip>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                ) : (
                <TableHead>
                  <TableRow>
                    {/* ID */}
                    <StyledTableCell show={generacionMasiva && selectedMoviles.length == 0 } style={{ maxWidth: "22px" }}>
                      <StyledTooltip 
                        title={intl.formatMessage({
                          id: 'render.generacionMasiva.seleccionar_todos',
                          defaultMessage: 'Seleccionar Todos',
                        })}
                        arrow
                        placement="top"
                      >
                        <input type="checkbox" checked={allChecked} onChange={handleChecked('all')} style={{marginRight: "15px"}} className="customCheckbox"/>
                      </StyledTooltip>
                    </StyledTableCell>
                    <SortableCell show={columnasVisibles.marca} field="marca" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_marca.label" label="Marca" />
                    <StyledTableCell show={columnasVisibles.disponibilidadEnabled} align="left">
                      <i
                        id="disponibilidad"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="fa fa-filter cursor-pointer"
                        style={{ marginRight: "10px" }}
                      ></i>
                      <div className="dropdown-menu" aria-labelledby="dLabel">
                        <p
                          key="sss"
                          className="cursor-pointer dropdown-item"
                          style={{ margin: "0", padding: "5px 5px" }}
                          onClick={() => setQueryClasificadorEstados(filtroEstadosClasificador.disponibles)}
                        >
                          <FormattedMessage id="Disponible" defaultMessage="Disponible" />
                        </p>
                        <p
                          key="ss"
                          className="cursor-pointer dropdown-item"
                          style={{ margin: "0", padding: "5px 5px" }}
                          onClick={() => setQueryClasificadorEstados(filtroEstadosClasificador.nodisponibles)}
                        >
                          <FormattedMessage id="No_disponible" defaultMessage="No disponible" />
                        </p>
                      </div>  <FormattedMessage id="Disponibilidad" defaultMessage="Disponibilidad" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <i
                        id="dLabel"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="fa fa-filter cursor-pointer"
                        style={{ marginRight: "10px" }}
                      ></i>
                      <div className="dropdown-menu" aria-labelledby="dLabel">
                        {/* <p className="dropdown-item">Action</p> */}
                        {estados
                          ? estados.map((estado,i) => (
                            <p
                              key={i}
                              className="cursor-pointer dropdown-item"
                              style={{ margin: "0", padding: "5px 5px" }}
                              onClick={() => setFilterQuery({...filterQuery,estado:estado.value})}
                            >
                              {estado.label}
                            </p>
                          ))
                          : ""}
                      </div>  <FormattedMessage id="Estado" defaultMessage="Estado" />
                    </StyledTableCell>
                    <SortableCell show={columnasVisibles.unidadEnabled} field="unidad" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_unidad.label" label="Unidad" />
                    <SortableCell show={columnasVisibles.chasisEnabled} field="chasis" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_chasis.label" label="Chasis" />
                    <SortableCell show={columnasVisibles.dominio} field="dominio" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_dominio.label" label="Dominio" />
                    <StyledTableCell show={columnasVisibles.rutaEnabled} align="left">
                      <FormattedMessage id="Ruta" defaultMessage="Ruta" />
                    </StyledTableCell>
                    <StyledTableCell show={columnasVisibles.movilReservaEnabled} align="left">
                      <FormattedMessage id="movilesGrid.render.column_movil_reserva.label" defaultMessage="Vehículo Reserva" />
                    </StyledTableCell>
                    <SortableCell show={columnasVisibles.modelo} field="modelo" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_modelo.label" label="Modelo" />
                    <StyledTableCell show={columnasVisibles.proxTareas} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="movilesGrid.rennder.column_prox_tareas.label" defaultMessage="Prox. Tareas" />
                    </StyledTableCell>
                    <SortableCell show={columnasVisibles.tipo} field="tipo" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_tipo.label" label="Tipo" />
                    <SortableCell show={columnasVisibles.paisEnabled} field="pais" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_pais.label" label="País" />
                    <SortableCell show={columnasVisibles.regionEnabled} field="region" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_region.label" label="Región" />
                    <SortableCell show={columnasVisibles.subRegionEnabled} field="subRegion" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_subRegion.label" label="Sub.Región" />
                    <SortableCell show={columnasVisibles.baseEnabled} field="base" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_base.label" label="Base" />
                    <SortableCell show={columnasVisibles.transportadoraEnabled} field="transportadora" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_transportadora.label" label="Transportadora" />
                    <SortableCell show={columnasVisibles.rentingEnabled} field="rentadora" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_rentadora.label" label="Rentadora" />
                    <SortableCell show={columnasVisibles.titularEnabled} field="titular" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_titular.label" label="Titular" />
                    <SortableCell show={columnasVisibles.funcion} field="funcion" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_funcion.label" label="Función" />
                    <SortableCell show={columnasVisibles.companiaOrigenEnabled} field="companiaOrigen" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_cia_origen.label" label="Cía. Origen" />
                    <SortableCell show={columnasVisibles.centroCostosEnabled} field="centroCosto" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_centro_costos.label" label="Centro de Costos" />
                    <SortableCell show={columnasVisibles.cecosDireccionEnabled} field="cecosDireccion" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_centro_costos_direccion.label" label="CC. Dirección" />
                    <SortableCell show={columnasVisibles.cecosMercadoEnabled} field="cecosMercado" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_centro_costos_mercado.label" label="CC. Mercado" />
                    <SortableCell show={columnasVisibles.cecosGerenciaEnabled} field="cecosGerencia" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_centro_costos_gerencia.label" label="CC. Gerencia" />
                    <SortableCell show={columnasVisibles.cecosAreaEnabled} field="cecosArea" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_centro_costos_area.label" label="CC. Area" />
                    <SortableCell show={columnasVisibles.responsable1Enabled} field="responsable1" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_responsable1.label" label="Responsable 1" />
                    <StyledTableCell show={columnasVisibles.responsable2Enabled} align="left">
                      <FormattedMessage id="movilesGrid.rennder.column_responsable2.label" defaultMessage="Responsable 2" />
                    </StyledTableCell>                  
                    <SortableCell show={columnasVisibles.supervisorEnabled} field="supervisor" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.render.column_supervisor.label" label="Supervisor" />
                    <SortableCell show={columnasVisibles.temporalEnabled} field="temporal" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.render.column_temporal.label" label="Temporal" />
                    <StyledTableCell align="left"></StyledTableCell>
                    <SortableCell show={columnasVisibles.medidor} field="medidor" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.rennder.column_medidor.label" label="Medidor" />
                    <StyledTableCell show={columnasVisibles.esReservaEnabled} align="left">
                      <FormattedMessage id="movilesGrid.rennder.column_es_reserva.label" defaultMessage="¿Es reserva?"/>
                    </StyledTableCell>
                    <StyledTableCell show={(columnasVisibles.editKmEnabled && permissions.canModifyKM) ? true : false} align="left">
                      <FormattedMessage id="movilesGrid.rennder.column_update_km.label" defaultMessage="Actualizar Medidor" />
                    </StyledTableCell>
                    <SortableCell show={columnasVisibles.ultimaBipeoEnabled} field="ultimoBipeo" sort={sortQuery} onSort={requestSort} messageId="movilesGrid.render.column_ultima_bipeo.label" label="Último bipeo" />
                    <StyledTableCell align="left"><FormattedMessage id="movilesGrid.rennder.column_acciones.label" defaultMessage="Acciones" /></StyledTableCell>
                  </TableRow>
                </TableHead>
                )}
                <TableBody>
                  <GridLoadingRow visible={loading} columns={columnasALaVista} />
                  {!loading &&
                    (moviles.length > 0 ?
                    moviles.map((movil) => (
                      <MovilesGridRow
                        columnsEnabled={columnasVisibles}
                        permissions={permissions}
                        key={'movilesGridRow_' + movil.id}
                        baseUrl = {props.match.url}
                        movil={movil}
                        generacionMasiva={generacionMasiva}
                        selectedMoviles={selectedMoviles}
                        setSelectedMoviles={setSelectedMoviles}
                        handleChecked={handleChecked}
                        estados={estados}
                        filtroEstadosClasificador={filtroEstadosClasificador}
                        estadosClasificador={estadosClasificador}
                        movilesReserva={movilesReserva}
                        onActualizarMovilReserva={handleActualizarMovil}
                        movilAsignado={movilesAsignados[movil.id] ? movilesAsignados[movil.id] : null}
                      />
                    ))
                    :
                    <GridEmptyRow
                      columns={columnasALaVista}
                      messageId="movilesGrid.rennder.no_data_table"
                      label="No se encontraron resultados..."
                    />
                    )}
                </TableBody>
              </Table>
            </TableContainer>
            <GridPagination
              count={paginationCount}
              page={pagination.page}
              perPage={pagination.perPage}
              onPageChange={handleChangePage}
              onPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </>
  )
}

const ButtonsTableTop = (props)=> {
  const intl = props.intl;
  const permissions = props.permissions;

  const botonImportar = (
    <button disabled={!permissions.movilesImportar} onClick={() => props.handleModalImportOpen()} className="btn-light dropdown-item" style={{ cursor: "pointer" }} type="button">
      <FormattedMessage id="movilesGrid.tools_import.importar_vehiculos" defaultMessage="Importar Vehículos" />
    </button>
  );

  const puedeExportar = ConfigBusiness.get('frontend.restringirExports') === "false" ||
    (ConfigBusiness.get('frontend.restringirExports') === "true" && permissions.movilesExportar);

  return(
    <GridToolbar>
      {puedeExportar ?
        <GridToolbarButton
          onClick={() => props.handleModalExportOpen()}
          icon="ft-upload"
          messageId="movilesGrid.tools_export.title_exportar_a_excel"
          label="Exportar a Excel"
        />
      : null}
      {(permissions.movilesCrear || permissions.movilesModificar || permissions.canModifyKM) &&
        <div className="dropdown">
          {/* `dropdownToggle` pone el data-toggle que abre el menú de Bootstrap. Sin eso el
              botón se ve igual y no despliega nada: es el bug que apareció en VEC-3721 al
              migrar el export de tickets, y que sólo se detecta mirando visibilidad. */}
          <GridToolbarButton
            id="dropdownMenu2"
            className="btn buttons-collection dropdown-toggle"
            dropdownToggle={true}
            icon="ft-download"
            messageId="movilesGrid.tools_import.title_importar"
            label="Importar"
          />
            <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
              {(permissions.movilesCrear || permissions.movilesModificar) &&
                (permissions.movilesImportar ?
                  (botonImportar)
                  :
                  <StyledTooltip
                    title={intl.formatMessage({
                      id: 'movilesGrid.tools_import.permiso_importar',
                      defaultMessage: 'Sin permiso, contacte al administrador.',
                    })}
                    placement='top'
                    arrow
                  >
                    {botonImportar}
                  </StyledTooltip>
                )
              }
              {(permissions.canModifyKM) &&
              <button onClick={()=>props.handleModalImportMedidorOpen()} className="btn-light dropdown-item" style={{cursor: "pointer"}} type="button">
                <FormattedMessage id="movilesGrid.tools_import.importar_lecturas" defaultMessage="Importar Lecturas de Medidor" />
              </button>
              }
            </div>
        </div>
      }
    </GridToolbar>
  )
}

export default MovilesGrid
                          
